var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1456 4340 c-107 -33 -185 -152 -173 -265 9 -89 61 -165 142 -208 l40 -22 1735 0 1735 0 40 22 c92 49 139 127 140 228 0 102 -48 183 -138 232 -30 17 -129 18 -1762 20 -952 1 -1743 -2 -1759 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 2809 c-90 -18 -182 -113 -196 -204 -10 -67 3 -129 39 -182 42 -62 99 -101 167 -113 37 -7 843 -9 2385 -8 2110 3 2333 5 2365 19 52 24 97 65 128 118 23 39 27 57 27 121 0 64 -4 82 -27 121 -31 53 -76 94 -128 118 -32 15 -254 16 -2375 17 -1325 1 -2360 -2 -2385 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2479 1266 c-222 -79 -234 -378 -19 -475 44 -20 59 -21 1246 -21 1337 0 1256 -4 1332 69 57 56 77 104 77 186 -1 52 -6 81 -22 111 -31 58 -104 119 -158 133 -68 17 -2407 15 -2456 -3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ed98dc9921f5ae35fdc81a701a10093d.svg";
export { ForwardRef as ReactComponent };